import { forwardRef, Ref, type SVGProps } from 'react';

const SvgArrowRightLineIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5 12h14m-7 7 7-7-7-7"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgArrowRightLineIcon);
export default ForwardRef;
